<div class="card">
  <div class="card-header">
    <h5>Referrals</h5>
    <button type="button" class="btn btn-primary ms-auto" [ngbPopover]="referralProgramPopOver" trigger="click">
      <fa-icon [icon]="faQuestion"></fa-icon>
    </button>
  </div>
  <div class="card-body">
    <div class="row mb-3">
      <div class="card p-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <strong>Referral Code</strong>
            <div class="col text-end">
              <button id="generateCodeBtn" class="btn btn-primary" *ngIf="!referralCode" (click)="generateReferralCode();">Generate</button>
              <span *ngIf="referralCode">{{referralCode}} &nbsp;
                <button type="button" class="btn btn-outline-primary" (click)="copyReferralLink();" ngbTooltip="Copy Referral Link" aria-label="Copy">
                  <fa-icon [icon]="faCopy"></fa-icon>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul class="list-group scrollable mt-3" style="height: 226px;">
      <li *ngFor="let referral of organizationReferralLists" class="list-group-item">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <strong style="line-height: 21px;">{{ referral.referredOrganization?.name }}</strong>
            <small class="text-muted">Signed Up on {{ referral.signUpDate | date:'longDate':'UTC' }}</small>
            <small class="text-muted">
              <span>Applied on </span>
              <span *ngIf="!referral.appliedDate">N/A</span>
              <span *ngIf="referral.appliedDate">{{ referral.appliedDate | date:'longDate':'UTC' }}</span>
            </small>
            <small class="text-muted">
              <span>Credited on </span>
              <span *ngIf="!referral.creditedDate">N/A</span>
              <span *ngIf="referral.creditedDate">{{ referral.creditedDate | date:'longDate':'UTC' }}</span>
            </small>
          </div>
          <div class="ms-auto my-auto">
            <div [ngSwitch]="referral.status">
              <div *ngSwitchCase="'PENDING'" class="badge text-bg-warning">Pending</div>
              <div *ngSwitchCase="'APPLIED'" class="badge text-bg-success">Applied</div>
              <div *ngSwitchCase="'CREDITED'" class="badge text-bg-success">Credited</div>
              <div *ngSwitchCase="'CANCELED'" class="badge text-bg-danger">Canceled</div>
            </div>
          </div>
        </div>
      </li>
      <li *ngIf="organizationReferralLists.length == 0" class="list-group-item">No Referrals</li>
    </ul>
  </div>
</div>


<ng-template #referralProgramPopOver>
  <strong>What is a Referral?</strong>
  <p class="mb-0">Share your unique referral link and earn rewards!</p>
  <ul>
    <li>When someone signs up using your code,<strong> they get an extended free trial.</strong></li>
    <li>Once they become a paying user,<strong> you'll get a free month credited to your account.</strong></li>
  </ul>
  <p>It's a win-win — help others streamline their lighting business and get rewarded when they do!</p>
  <strong>Referral Statuses</strong>
  <ul>
    <li><strong>Pending</strong> Your referral code has been used to register an organization.</li>
    <li><strong>Applied</strong> An organization that used your referral code has become a paying customer.</li>
    <li><strong>Credited</strong> Your organization has been credited a free month for this referral.</li>
  </ul>
</ng-template>